export { GainChip } from "./GainChip"
export type { GainChipProps } from "./GainChip"
